import { CHECKOUT_FORM_NAME } from '../../constants';
import { ContactFields } from '../../models/order';
import { CheckoutState } from '../../state';
import { getFormValues } from './pureSelectors';

export const getIsContactInformationComplete = (state: CheckoutState) => {
    const { buyer } = getFormValues(state, CHECKOUT_FORM_NAME) || {};

    return !!(
        buyer?.[ContactFields.EMAIL] &&
        buyer?.[ContactFields.FIRST_NAME] &&
        buyer?.[ContactFields.LAST_NAME]
    );
};
